<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-col-12 p-lg-6 p-mt-2">
                        <div class="p-formgrid p-grid">
                            <div class="p-field p-col-10 p-lg-10">
                                <label class="p-mr-2">หน่วยงานที่รับผิดชอบ</label>
                                <Button
                                    @click="
                                        showOrganize = true;
                                        setOpenModal_OrganizeMulti = 'search';
                                    "
                                    icon="pi pi-plus"
                                    class="p-button-success"
                                    ref="TextBox_1_search"
                                    @keyup.left="moveFocus($event, 'TextBox_4_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_2_search', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                        <div class="p-field p-col p-mt-2" style="margin-left: -10px">
                            <DataTable
                                :value="organize_table"
                                :scrollable="true"
                                scrollHeight="500px"
                                :paginator="true"
                                :rows="3"
                                dataKey="id"
                                :rowHover="true"
                                :selection.sync="selectedOrganizeData"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                            >
                                <template #empty>{{ $t('TableEmpty') }}</template>
                                <Column field="fs_tname" :header="$t('id_operating_name')" :sortable="true" headerStyle="width: 20rem">
                                    <template #body="dataTable">
                                        <div hidden>{{ dataTable.data.organize_id }}</div>
                                        {{ dataTable.data.fs_tname }}
                                    </template>
                                </Column>
                                <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                    <template #body="dataTable">
                                        <div class="p-formgrid p-grid">
                                            <div class="p-field p-col-6">
                                                <Button
                                                    @click="
                                                        // displayConfirmation = true;
                                                        deleteTable = 'organize';
                                                        organizeDelete = dataTable.data;
                                                        alertDisplay(organizeDelete, deleteTable);
                                                    "
                                                    icon="pi pi-trash"
                                                    :label="$t('deleteBtn')"
                                                    class="p-button-rounded p-button-danger"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>

                    <div class="p-col p-mt-3 p-ml-3">
                        <div class="p-formgrid p-grid p-col p-mt-1">
                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="r_name">{{ $t('ชื่อ') }}</label>
                                <InputText
                                    id="r_name"
                                    type="text"
                                    v-model="r_name"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="r_unit_th">{{ $t('รหัสสังกัด') }}</label>
                                <InputText
                                    id="r_unit_th"
                                    type="text"
                                    v-model="r_unit_th"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="r_code_th">{{ $t('สัญญาณเรียกขาน') }}</label>
                                <InputText
                                    id="r_code"
                                    type="text"
                                    v-model="r_code"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>

                            <div class="p-field p-col-12 p-lg-6 p-mt-2">
                                <label for="r_status">{{ $t('สถานะ') }}</label>
                                <InputText
                                    id="r_status"
                                    type="text"
                                    v-model="r_status"
                                    ref="TextBox_2_search"
                                    @keyup.left="moveFocus($event, 'TextBox_1_search', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_3_search', 'Button')"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-field p-col">
                    <div class="p-formgrid p-grid p-jc-end p-mt-5">
                        <!-- Doe โหลด โทรศัพท์ -->
                        <Button
                            v-if="window.width <= 430"
                            @click="MobileClearSearchField()"
                            :label="$t('clearBtn')"
                            class="p-button-clear p-ml-3 p-mr-3"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                        <Button
                            v-else
                            @click="clearSearchField()"
                            :label="$t('clearBtn')"
                            class="p-button-clear p-ml-3 p-mr-3"
                            ref="TextBox_3_search"
                            @keyup.left="moveFocus($event, 'TextBox_2_search', 'Input')"
                            @keyup.right="moveFocus($event, 'TextBox_4_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                        <!-- Doe โหลด โทรศัพท์ -->
                        <Button
                            @click="searchVolunteerRescue()"
                            :label="$t('searchBtn')"
                            class="p-button-info"
                            ref="TextBox_4_search"
                            @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_1_search', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_2_search', 'Input')"
                        />
                    </div>
                </div>

                <div class="p-formgrid p-grid p-col p-mt-1">
                    <!-- <div class="p-field p-col-12 p-mt-2" id="text_Footer">
              {{ text_Footer }}
            </div> -->
                    <text-footer
                        :data="Data_text_Footer"
                        :checkShow="text_Footer"
                        :countItem="volunteer_rescue_Table.length.toLocaleString('en-US')"
                    />
                </div>
            </div>
        </Fieldset>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize" :style="{ width: '80%', overflow: 'auto' }">
            <organize-table
                @selectOrganization="selectedOrganize_passValue"
                :parentmessage="parentmessage_organize"
                :checkForm="checkSelectedOrganize(setOpenModal_OrganizeMulti)"
            ></organize-table>
        </Dialog>

        <Dialog :modal="true" :header="$t('OrganizeModalHeader')" :visible.sync="showOrganize_Form" :style="{ width: '80%', overflow: 'auto' }">
            <organize-form @selectOrganization="selectedOrganize_passValue_Form"></organize-form>
        </Dialog>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? volunteer_rescue_Table : []"
                scrollHeight="500px"
                :paginator="true"
                :rows="10"
                :loading="loading"
                :sortOrder="1"
                sortField="index"
                dataKey="rescue_id"
                ref="dt"
                :exportFilename="`ข้อมูลจุดอาสาสมัคร-${date}`"
                :rowHover="true"
                :selection.sync="selectedVolunteerRescue"
                :filters="filters"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="handleAddClick" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button
                                @click="exportCSV()"
                                :label="$t('exportBtn')"
                                style="background-color: green; width: 100%; border: 1px solid green"
                            />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>
                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div
                            class="table-header"
                            id="TABLE_EDIT"
                            style="padding: 7px"
                            v-if="selectedVolunteerRescue && selectedVolunteerRescue.length > 0"
                        >
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left" >
                  <i class="pi pi-search" />
                  <InputText
                    v-model="filters['global']"
                    :placeholder="$t('searchHeader')"
                  />
                </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>

                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedVolunteerRescue.length === volunteer_rescue_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedVolunteerRescue.some((item) => item.rescue_id === slotProps.data.rescue_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>

                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div style="text-align: center" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_rescue_name == true">
                    <Column
                        field="rescue_name"
                        :header="$t('ชื่อจุดอาสาสมัคร')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_rescue_name == true">
                                {{ dataTable.data.rescue_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_rescue_unit_th == true">
                    <Column
                        field="rescue_unit_th"
                        :header="$t('รหัสสังกัด')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_rescue_unit_th == true">
                                {{ dataTable.data.rescue_unit_th }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_rescue_code == true">
                    <Column
                        field="rescue_code"
                        :header="$t('สัญญาณเรียกขาน')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_rescue_code == true">
                                <div v-if="dataTable.data.rescue_code == '[]'">-</div>
                                <div v-else>
                                    {{ dataTable.data.rescue_code }}
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_rescue_status == true">
                    <Column field="rescue_status" :header="$t('สถานะ')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_rescue_status == true">
                                <div v-if="dataTable.data.rescue_status == ''">-</div>
                                <div v-else>{{ dataTable.data.rescue_status }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_service_time == true">
                    <Column
                        field="service_time"
                        :header="$t('ระยะเวลาการให้บริการ (ชั่วโมง)')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_service_time == true">
                                {{ dataTable.data.service_time }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_fire_station == true">
                    <Column
                        field="fire_station"
                        :header="$t('หน่วยงานที่รับผิดชอบ')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_fire_station == true">
                                <div v-if="dataTable.data.fire_station == ''">-</div>
                                <div v-else>{{ dataTable.data.fire_station }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_subdistrict == true">
                    <Column
                        field="subdistrict"
                        :header="$t('แขวง/ตำบล')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_subdistrict == true">
                                <div v-if="dataTable.data.subdistrict == null || dataTable.data.subdistrict == ''">-</div>
                                <div v-else>{{ dataTable.data.subdistrict }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_country == true">
                    <Column field="country" :header="$t('เขต/อำเภอ')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_country == true">
                                <div v-if="dataTable.data.country == '' || dataTable.data.country == null">-</div>
                                <div v-else>{{ dataTable.data.country }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_province == true">
                    <Column field="province" :header="$t('จังหวัด')" :sortable="true" :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div v-if="columns_province == true">
                                <div v-if="dataTable.data.province == '' || dataTable.data.province == null">-</div>
                                <div v-else>{{ dataTable.data.province }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_rescue_latitude == true">
                    <Column
                        field="rescue_latitude"
                        :header="$t('latitude')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_rescue_latitude == true">
                                <div v-if="dataTable.data.rescue_latitude == ''">-</div>
                                <div v-else>{{ parseFloat(dataTable.data.rescue_latitude).toFixed(6) }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_rescue_longitude == true">
                    <Column
                        field="rescue_longitude"
                        :header="$t('longitude')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_rescue_longitude == true">
                                <div v-if="dataTable.data.rescue_longitude == ''">-</div>
                                <div v-else>{{ parseFloat(dataTable.data.rescue_longitude).toFixed(6) }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_rescue_remark == true">
                    <Column
                        field="rescue_remark"
                        :header="$t('รายละเอียดเพิ่มเติม')"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_rescue_remark == true">
                                <div v-if="dataTable.data.rescue_remark == ''">-</div>
                                <div v-else>{{ dataTable.data.rescue_remark }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ formatThaiDate(dataTable.data.date_create) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ formatThaiDate(dataTable.data.date_update) }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_index ||
                        columns_rescue_name ||
                        columns_rescue_unit_th ||
                        columns_rescue_code ||
                        columns_rescue_status ||
                        columns_fire_station ||
                        columns_service_time ||
                        columns_subdistrict ||
                        columns_country ||
                        columns_province ||
                        columns_rescue_latitude ||
                        columns_rescue_longitude ||
                        columns_rescue_remark ||
                        columns_img ||
                        columns_evacuation_name ||
                        columns_disaster ||
                        columns_evacuation_location ||
                        columns_evacuation_entry ||
                        columns_evacuation_exit ||
                        columns_evacuation_area ||
                        columns_evacuation_capacity ||
                        columns_evacuation_contact_name ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid" v-if="checkDiv14()">
                                <div class="p-formgrid col_manege" style="text-align: center">
                                    <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                        <Button
                                            @click="
                                                volunteerRescueModal = true;
                                                editData(dataTable.data.rescue_id);
                                                temp = dataTable.data.rescue_id;
                                            "
                                            icon="pi pi-pencil"
                                            :label="table_editBTN"
                                            class="p-button-rounded p-button-warning"
                                        />
                                    </div>
                                    <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                        <Button
                                            @click="
                                                temp = dataTable.data.rescue_id;
                                                deleteAt = '';
                                                alertDisplay(temp, deleteAt);
                                            "
                                            icon="pi pi-trash"
                                            :label="table_deleteBTN"
                                            class="p-button-rounded p-button-danger"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                {{ 'ไม่มีสิทธิ์จัดการข้อมูลนี้' }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>

        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="volunteerRescueModal"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :header="header"
            :closable="loadingCreate ? false : true"
            id="evacuation_manage"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('irl_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-5">
                    <div class="p-formgrid p-grid">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2" style="margin-top: -5px">
                            <label for="rescue_name">{{ $t('ชื่อ') }} <span class="required-input">*</span></label>
                            <InputText
                                id="rescue_name"
                                type="text"
                                v-model="rescue_name"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_rescue_name && !rescue_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_rescue_name && !rescue_name">{{ $t('กรุณาระบุชื่อจุดอาสาสมัคร') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2" style="margin-top: -5px">
                            <label for="rescue_unit_th">{{ $t('รหัสสังกัด') }} <span class="required-input">*</span></label>
                            <InputText
                                id="rescue_unit_th"
                                type="text"
                                v-model="rescue_unit_th"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_rescue_unit_th && !rescue_unit_th
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_rescue_unit_th && !rescue_unit_th">{{ $t('กรุณาระบุรหัสสังกัด') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2" style="margin-top: -5px">
                            <label for="rescue_code">{{ $t('สัญญาณเรียกขาน') }} <span class="required-input">*</span></label>
                            <InputText
                                id="rescue_code"
                                type="text"
                                v-model="rescue_code"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_rescue_code && !rescue_code
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_rescue_code && !rescue_code">{{ $t('กรุณาระบุสัญญาณเรียกขาน') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-4 p-mt-2" style="margin-top: -5px">
                            <label for="rescue_status">{{ $t('สถานะ') }} <span class="required-input">*</span></label>
                            <InputText
                                id="rescue_status"
                                type="text"
                                v-model="rescue_status"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_rescue_status && !rescue_status
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_rescue_status && !rescue_status">{{ $t('กรุณาระบุสถานะ') }}</small>
                        </div>

                        <div class="p-field p-col-8 p-lg-4 p-mt-2">
                            <label for="rescue_selectedOrganize">{{ $t('response_agency') }} <span class="required-input">*</span></label>
                            <InputText
                                id="rescue_selectedOrganize"
                                type="text"
                                v-model="rescue_selectedOrganize.name"
                                disabled
                                :class="{
                                    'p-invalid': error_rescue_organize && !rescue_selectedOrganize.name
                                }"
                            />
                            <small class="p-invalid" v-if="error_rescue_organize && !rescue_selectedOrganize.name">{{
                                $t('rescue_organize_validate')
                            }}</small>
                        </div>

                        <div class="p-field p-lg-2">
                            <div>
                                <Button
                                    @click="showOrganize_Form = true"
                                    icon="pi pi-ellipsis-h"
                                    class="p-button-secondary p-mt-5 p-mr-2"
                                    ref="TextBox_2"
                                    @keyup.left="moveFocus($event, 'TextBox_1', 'Input')"
                                    @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                                    @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                                />
                                <Button
                                    @click="rescue_selectedOrganize = {}"
                                    icon="pi pi-times"
                                    class="p-button-danger p-mt-5"
                                    ref="TextBox_3"
                                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                                    @keyup.right="moveFocus($event, 'TextBox_4', 'Input')"
                                    @keyup.down="moveFocus($event, 'TextBox_5', 'Button')"
                                />
                            </div>
                        </div>

                        <div class="p-field p-col-8 p-lg-4 p-mt-2">
                            <label for="service_time">{{ $t('ระยะเวลาการให้บริการ (ชั่วโมง)') }} <span class="required-input">*</span></label>
                            <InputText
                                id="service_time"
                                type="text"
                                v-model="service_time"
                                required="true"
                                autofocus
                                :class="{
                                    'p-invalid': error_service_time && !service_time
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_18', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_4', 'Input')"
                            />
                            <small class="p-invalid" v-if="error_service_time && !service_time">{{
                                $t('กรุณาระบุระยะเวลาการให้บริการ (ชั่วโมง)')
                            }}</small>
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 1/9  @input="inputMap_PAT_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col">
                            <label for="provinceOptions">{{ $t('province') }}</label>
                            <Dropdown
                                v-model="rescue_selectedProvince"
                                :options="provinceOptions"
                                optionLabel="province_name"
                                :placeholder="$t('placeholderSelectBox')"
                                :filter="true"
                            >
                                <template #value="slotProps">
                                    <div v-if="slotProps.value && slotProps.value.province_name">
                                        {{ slotProps.value.province_name }}
                                    </div>
                                    <div v-else>{{ $t('placeholderSelectBox') }}</div>
                                </template>
                                <template #option="slotProps">
                                    <div>{{ slotProps.option.province_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col">
                            <label for="amphurOptions">{{ $t('amphur') }}</label>
                            <Dropdown
                                :disabled="rescue_isDisabledAmphur == 1"
                                v-model="rescue_selectedAmphur"
                                @input="inputMap_PAT_latlon"
                                @change="someHandler('ch-amphur')"
                                :options="amphurOptions"
                                optionLabel="amphur_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="amphurOptions">
                                    <div v-if="amphurOptions.value">
                                        <div>{{ amphurOptions.value.amphur_name }}</div>
                                    </div>
                                </template>
                                <template #option="amphurOptions">
                                    <div>{{ amphurOptions.option.amphur_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col">
                            <label for="tambonOptions">{{ $t('tambon') }}</label>
                            <Dropdown
                                :disabled="rescue_isDisabledTambon == 1"
                                v-model="rescue_selectedTambon"
                                @input="inputMap_PAT_latlon"
                                :options="tambonOptions"
                                optionLabel="tambon_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="tambonOptions">
                                    <div v-if="tambonOptions.value">
                                        <div>{{ tambonOptions.value.tambon_name }}</div>
                                    </div>
                                </template>
                                <template #option="tambonOptions">
                                    <div>{{ tambonOptions.option.tambon_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>

                    <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" -->
                    <div class="p-formgrid p-grid p-mt-3">
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="rescue_lat">{{ $t('lat') }}</label>
                            <InputText
                                id="rescue_lat"
                                type="text"
                                v-model="rescue_lat"
                                @input="inputMap_latlon"
                                ref="TextBox_13"
                                @keyup.left="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_11', 'Input')
                                "
                                @keyup.right="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.up="moveFocus($event, 'TextBox_11', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4 p-mt-2">
                            <label for="rescue_lon">{{ $t('lon') }}</label>
                            <InputText
                                id="rescue_lon"
                                type="text"
                                v-model="rescue_lon"
                                @input="inputMap_latlon"
                                ref="TextBox_14"
                                @keyup.left="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_15', 'Button')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_10', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                        <!-- Doe เพิ่มหมุด map V.2 2/9  @input="inputMap_latlon" จบ-->
                        <!-- Doe:  เพิ่ม มุดmap 1/4 -->
                        <div class="p-field p-col-12 p-lg-4 p-mt-5">
                            <Button
                                @click="
                                    displayMap = true;
                                    sendM(rescue_lat, rescue_lon);
                                    sendM_PAT(rescue_selectedTambon, rescue_selectedAmphur, rescue_selectedProvince);
                                "
                                icon="pi pi-map-marker"
                                :label="$t('openMapBtn')"
                                class="p-button-secondary"
                                ref="TextBox_15"
                                @keyup.left="moveFocus($event, 'TextBox_14', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_16', 'Input')"
                                @keyup.up="
                                    moveFocus($event, contact_phone_office && contact_phone_office !== '-' ? 'TextBox_12' : 'TextBox_10', 'Input')
                                "
                                @keyup.down="moveFocus($event, 'TextBox_16', 'Input')"
                            />
                        </div>
                        <!-- Doe:  เพิ่ม มุดmap 1/4 จบ-->
                    </div>

                    <!-- <small class="p-invalid" style="margin-right: .5rem;"
                  v-if="error_latlon_country">กรุณาระบุข้อมูล ละติจูดและลองจิจูด ที่อยู่ในประเทศไทย</small> -->

                    <!-- Doe เพิ่มหมุด map V.2 3/9  -->
                    <small class="warningLATLON" v-if="this.error_latlon_P || this.error_latlon_A || this.error_latlon_T || error_latlon_country"
                        >ข้อควรระวัง : ข้อมูลพิกัดที่คุณเลือกไม่สามารถระบุ
                        <span v-if="this.error_latlon_P || error_latlon_country"> จังหวัด </span>
                        <span v-if="this.error_latlon_A || error_latlon_country"> เขต/อำเภอ </span>
                        <span v-if="this.error_latlon_T || error_latlon_country"> แขวง/ตำบล </span>
                        <span> ได้ </span>
                    </small>
                    <!-- Doe เพิ่มหมุด map V.2 3/9  จบ-->

                    <div class="p-formgrid p-grid p-mt-3 p-mb-3">
                        <div class="p-field p-col-12 p-lg-6">
                            <label for="rescue_remark">{{ $t('remark') }}<span class="required-input"> </span></label>
                            <InputText
                                id="rescue_remark"
                                type="text"
                                v-model="rescue_remark"
                                ref="TextBox_16"
                                @keyup.left="moveFocus($event, 'TextBox_15', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_17', 'Button')"
                                @keyup.up="moveFocus($event, 'TextBox_13', 'Input')"
                                @keyup.down="moveFocus($event, 'TextBox_17', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-3">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_17"
                    @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_16', 'Input')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_17"
                    @keyup.left="moveFocus($event, 'TextBox_16', 'Input')"
                    @keyup.right="moveFocus($event, 'TextBox_18', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_16', 'Input')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="isEditMode ? updateVolunteerRescue() : saveVolunteerRescue()"
                    ref="TextBox_18"
                    @keyup.left="moveFocus($event, 'TextBox_17', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_16', 'Input')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete(temp)" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('map')" :visible.sync="displayMap" :style="{ width: '700px', overflow: 'auto' }">
            <div class="confirmation-content p-mt-3" style="padding-bottom: 20px">
                <!-- Doe : เพิ่ม มุดmap 2/4 -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  -->
                <map-area @selectMap="selectMap_passValue" :latlon="this.latlon" :PAT="this.PAT" :FSS="{}" @selectMap_PAT="receiveM_PAT"></map-area>
                <!-- <map-area @selectMap="selectMap_passValue" :latlon="this.latlon"  ></map-area> -->
                <!-- Doe เพิ่มหมุด map V.2 4/9  จบ-->
                <!-- Doe :  เพิ่ม มุดmap 2/4 -->
            </div>
            <Button :label="$t('saveBtn')" icon="pi pi-check" class="p-button-text" @click="selectMap_displayMap()" autofocus />
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ $t('ConfirmCloseModalSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Image -->

        <Galleria
            :value="imgTable"
            containerStyle="max-width: 850px"
            :circular="true"
            :fullScreen="true"
            :showItemNavigators="false"
            :showThumbnails="false"
            :visible.sync="displayBasic2"
        >
            <template #item="slotProps">
                <img :src="imgTable" class="imgDia" alt="" />
            </template>
        </Galleria>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
import organizeForm from '../FireStationTableForm.vue';
import organizeTable from '../../Report/FireStationMultiSelectTable.vue';
import mapArea from '../Map';
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import { font } from "../../../../public/assets/font/Sarabun-Regular-normal";
// Doe : PDF 2/3 จบ
import moment from 'moment';
import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'information-volunteer-rescue',
    components: {
        organizeTable,
        organizeForm,
        mapArea,
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            provinceOptions: [],
            rescue_selectedProvince: null,
            r_code: '',
            error_rescue_status: false,
            rescue_status: '',
            rescue_selectedOrganize: {},
            selectedOrganize: {},
            r_name: '',
            r_unit_th: '',
            r_code_th: '',
            r_status: '',

            rescue_name: '',
            rescue_unit_th: '',
            rescue_code: '',
            status: '',
            service_time: '',

            rescue_selectedAmphur: null,
            rescue_selectedTambon: null,
            rescue_lat: null,
            rescue_lon: null,
            rescue_remark: '',
            date_create_form: '',
            date_update_form: '',
            main_organize: '',
            organize_status: '',

            multiSelectClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/6
            filter: '',
            dropdownClearFilerValue: 0,
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/6 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            volunteer_rescue_Table: [],
            loading: false,
            selectedProvince: null,
            amphurOptions: [],
            selectedAmphur: null,
            isDisabledAmphur: 1,
            tambonOptions: [],
            selectedTambon: null,
            isDisabledTambon: 1,

            filters: {},
            temp: null,
            disasterTable: null,
            showOrganize: false,
            showOrganize_Form: false,
            selectedVolunteerRescue: [],

            selectedOrganizeData: [],

            displayConfirmation: false,
            deleteTable: '',
            displayMap: false,
            deleteAt: '',

            disaster_table: [],
            disasterOptions: [],
            disasterSelect: null,

            header: this.$i18n.t('ivr_modal_title_add'),
            selectedData: '',

            volunteerRescueModal: false,

            rescue_location_detail: '',
            rescue_selectedDisaster: null,

            rescue_isDisabledAmphur: 1,
            rescue_isDisabledTambon: 1,
            rescue_access_main: '',
            rescue_access_tempolary: '',
            rescue_entry: '',
            rescue_exit: '',
            rescue_area: '',
            rescue_capacity: '',
            rescue_contact_name: '',
            rescue_contact_phone: '',

            iev_phone: [],
            contact_phone: '',
            contact_phone_office: '',
            contact_phone_office_ext: '',

            error_rescue_unit_th: false,
            error_rescue_code: false,
            error_status: false,
            error_service_time: false,

            error_contact_phone: false,
            error_contact_phone_office: false,
            error_contact_phone_office_ext: false,

            error_rescue_selectedProvince: false,
            error_rescue_selectedAmphur: false,
            error_rescue_selectedTambon: false,
            error_rescue_selectedOrganize: false,
            error_rescue_name: false,
            error_rescue_organize: false,

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            // เพิ่ม มุดmap 3/4
            //  Doe เพิ่มหมุด map V.2 5/9  -->
            latlon: {},
            PAT: {},
            sP: [],
            sA: [],
            error_latlon_country: false,
            error_latlon_land: false,
            error_latlon_P: false,
            error_latlon_A: false,
            error_latlon_T: false,
            //  Doe เพิ่มหมุด map V.2 5/9  จบ-->
            // เพิ่ม มุดmap 3/4 จบ

            organize_table: [],
            parentmessage_organize: null,
            setOpenModal_Organize: '',
            setOpenModal_OrganizeMulti: '',

            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบ

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'หน่วยงานที่รับผิดชอบ',
                    textShow: ''
                },
                {
                    DataName: 'ชื่อพื้นที่อพยพ',
                    textShow: ''
                },

                {
                    DataName: 'จังหวัด',
                    textShow: ''
                },
                {
                    DataName: 'เขต/อำเภอ',
                    textShow: ''
                },
                {
                    DataName: 'แขวง/ตำบล',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ข้อมูลจุดอาสาสมัคร',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 60,
            PDF_FontHeaderVer: 10,
            PDF_FontBodyVer: 7,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 28 },

                rescue_name: { cellWidth: 50 },
                disaster: { cellWidth: 45 },
                evacuation_lat: { cellWidth: 40 },
                evacuation_lon: { cellWidth: 40 },
                text_tel_detail: { cellWidth: 65 },
                date_create_ddmmyy: { cellWidth: 45 },
                date_update_ddmmyy: { cellWidth: 45 },
                evacuation_entry: { cellWidth: 40 },
                evacuation_exit: { cellWidth: 40 },
                evacuation_area: { cellWidth: 40 },
                evacuation_capacity: { cellWidth: 40 },
                evacuation_location: { cellWidth: 43 }
            },

            PDF_minCellWidthHor: 80,
            PDF_FontHeaderHor: 13,
            PDF_FontBodyHor: 11,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 },

                rescue_name: { cellWidth: 58 },
                rescue_unit_th: { cellWidth: 50 },

                rescue_rescue_codecode: { cellWidth: 50 },
                rescue_status: { cellWidth: 50 },
                service_time: { cellWidth: 50 },
                subdistrict: { cellWidth: 50 },
                country: { cellWidth: 50 },
                province: { cellWidth: 50 },
                rescue_latitude: { cellWidth: 55 },
                rescue_longitude: { cellWidth: 55 },
                rescue_remark: { cellWidth: 50 },
                date_create: { cellWidth: 70 },
                date_update: { cellWidth: 70 }
                // rescue_code: { cellWidth: 50 },

                // rescue_name: { cellWidth: 58 },
                // rescue_unit_th: { cellWidth: 50 },
                // text_tel_detail: { cellWidth: 90 },
                // evacuation_lat: { cellWidth: 55 },
                // evacuation_lon: { cellWidth: 55 },
                // evacuation_location: { cellWidth: 50 },
                // date_create_ddmmyy: { cellWidth: 70 },
                // date_update_ddmmyy: { cellWidth: 70 },
                // evacuation_entry: { cellWidth: 40 },
                // evacuation_exit: { cellWidth: 40 },
                // evacuation_area: { cellWidth: 40 },
                // evacuation_capacity: { cellWidth: 40 },
                // evacuation_contact_name: { cellWidth: 50 },
                // evacuation_name: { cellWidth: 70 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อจุดอาสาสมัคร', dataKey: 'rescue_name' },
                { title: 'รหัสสังกัด', dataKey: 'rescue_unit_th' },
                { title: 'สัญญาณเรียกขาน', dataKey: 'rescue_code' },
                { title: 'สถานะ', dataKey: 'rescue_status' },
                { title: 'ระยะเวลาการให้บริการ (ชั่วโมง)', dataKey: 'service_time' },
                { title: 'แขวง/ตำบล', dataKey: 'subdistrict' },
                { title: 'เขต/อำเภอ', dataKey: 'country' },
                { title: 'จังหวัด', dataKey: 'province' },
                { title: 'ละติจูด', dataKey: 'rescue_latitude' },
                { title: 'ลองจิจูด', dataKey: 'rescue_longitude' },
                { title: 'รายละเอียดเพิ่มเติม', dataKey: 'rescue_remark' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_img: true,
            columns_evacuation_name: true,
            columns_disaster: true,
            columns_rescue_name: true,
            columns_rescue_unit_th: true,
            columns_rescue_code: true,
            columns_rescue_status: true,
            columns_fire_station: true,
            columns_service_time: true,
            columns_subdistrict: true,
            columns_country: true,
            columns_province: true,
            columns_rescue_latitude: true,
            columns_rescue_longitude: true,
            columns_rescue_remark: true,

            columns_evacuation_location: true,
            columns_evacuation_entry: true,
            columns_evacuation_exit: true,
            columns_evacuation_area: true,
            columns_evacuation_capacity: true,

            columns_evacuation_latitude: true,

            columns_evacuation_longitude: true,

            columns_evacuation_contact_name: true,
            columns_evacuation_contact_phone: true,
            columns_province_name: true,
            columns_event_lat: true,
            columns_event_lon: true,

            columns_date_create: true,
            columns_date_update: true,

            GetData_ColumnsSearch: [],

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ
            url: null,
            imgTable: null,
            displayBasic2: false,
            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'PDF',
                            detail: 'แนวตั้ง',
                            life: 3000
                        });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({
                            severity: 'success',
                            summary: 'PDF',
                            detail: 'แนวนอน',
                            life: 3000
                        });

                        let columns = this.columnsSelector;
                        columns = columns.filter(function (item) {
                            return item.dataKey != 'image';
                        });

                        const Body_setCenter = ['index'];
                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        rescue_selectedProvince: {
            handler: async function (newVal) {
                if (newVal) {
                    await this.rescue_selectedProvince(newVal);
                }
            },
            deep: true
        },

        async volunteerRescueModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (
                    this.tempFor_displayConfirmationCloseModal == '' &&
                    this.selectedData == '' &&
                    this.rescue_name != '' &&
                    this.rescue_selectedOrganize.name != undefined &&
                    this.rescue_selectedProvince != null
                ) {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.volunteerRescueModal = false;

                            this.selectedData;
                            this.tempFor_displayConfirmationCloseModal = '';
                            this.rescue_name = '';
                            this.rescue_selectedOrganize = {};
                            this.rescue_location_detail = '';
                            this.rescue_access_main = '';
                            this.rescue_access_tempolary = '';
                            this.rescue_entry = '';
                            this.rescue_exit = '';
                            this.rescue_area = '';
                            this.rescue_capacity = '';
                            this.rescue_contact_name = '';
                            this.rescue_contact_phone = '';
                            this.rescue_lat = '';
                            this.rescue_lon = '';
                            this.rescue_remark = '';
                            this.rescue_selectedDisaster = null;
                            this.error_rescue_organize = false;
                            this.error_rescue_name = false;
                            this.disaster_table = [];

                            this.error_rescue_selectedProvince = false;
                            this.error_rescue_selectedAmphur = false;
                            this.error_rescue_selectedTambon = false;

                            this.error_rescue_status = false;
                            this.error_rescue_unit_th = false;
                            this.error_rescue_code = false;
                            this.error_status = false;
                            this.error_service_time = false;

                            this.error_contact_phone = false;
                            this.error_contact_phone_office = false;
                            this.error_contact_phone_office_ext = false;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;

                            this.url = null;
                            // document.getElementById("organize_uploadImageFile").value = "";

                            this.date_create_form = '';
                            this.date_update_form = '';
                        } else {
                            this.volunteerRescueModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/general/country`, {
                            body: { topic: 'get-province' }
                        })
                        .then((response) => {
                            (this.provinceOptions = response.data.data),
                                this.provinceOptions.splice(0, 0, {
                                    province_id: 'getall',
                                    province_name: this.$i18n.t('selectAll')
                                });
                        });
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterOptions = response.data.data),
                                this.disasterOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;

                    this.decodeToken = this.decodeJWT(localStorage.getItem('token'));
                    this.rescue_selectedOrganize = {
                        id: this.decodeToken.organize_id,
                        name: this.decodeToken.organize_name
                    };
                }

                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-province'
                        }
                    })
                    .then((response) => (this.provinceOptions = response.data.data));
                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterOptions = response.data.data;
                    });
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.volunteerRescueModal = true;
            }
        },

        async selectedProvince(val) {
            this.selectedAmphur = null;
            if (val != null) {
                this.isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.selectedProvince.province_id,
                            province_name: this.selectedProvince.province_name
                        }
                    })
                    .then((response) => {
                        (this.amphurOptions = response.data.data),
                            this.amphurOptions.splice(0, 0, {
                                amphur_id: 'getall',
                                amphur_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledAmphur = 1;
                this.selectedAmphur = null;
            }
        },

        async selectedAmphur(val) {
            this.selectedTambon = null;
            if (val != null) {
                this.isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.selectedAmphur.amphur_id,
                            amphur_name: this.selectedAmphur.amphur_name
                        }
                    })
                    .then((response) => {
                        (this.tambonOptions = response.data.data),
                            this.tambonOptions.splice(0, 0, {
                                tambon_id: 'getall',
                                tambon_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.isDisabledTambon = 1;
                this.selectedTambon = null;
            }
        },

        async rescue_selectedProvince(val) {
            if (val != null) {
                this.rescue_isDisabledAmphur = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-amphur',
                            province_id: this.rescue_selectedProvince.province_id,
                            province_name: this.rescue_selectedProvince.province_name
                        }
                    })
                    .then((response) => (this.amphurOptions = response.data.data));
                // this.inputMap_PAT_latlon()
            } else {
                this.rescue_isDisabledAmphur = 1;
                this.rescue_selectedAmphur = null;
                // this.inputMap_PAT_latlon()
            }
        },

        async rescue_selectedAmphur(val) {
            if (val != null) {
                this.rescue_isDisabledTambon = 0;
                await this.axios
                    .post(`${this.$url_service}/general/country`, {
                        body: {
                            topic: 'get-tambon',
                            amphur_id: this.rescue_selectedAmphur.amphur_id,
                            amphur_name: this.rescue_selectedAmphur.amphur_name
                        }
                    })
                    .then((response) => (this.tambonOptions = response.data.data));
                // this.inputMap_PAT_latlon()
            } else {
                this.rescue_isDisabledTambon = 1;
                this.rescue_selectedTambon = null;
                // this.inputMap_PAT_latlon()
            }
        },

        rescue_selectedDisaster(val) {
            if (val != null) {
                this.disaster_table = [];
                for (let i = 0; i < val.length; i++) {
                    this.disaster_table.push(val[i]);
                }
            }
        },

        selectedData(val) {
            if (val != '') {
                if (val.rescue_id != 'null') {
                    this.rescue_selectedProvince = {
                        province_id: val.province_id,
                        province_name: val.province_name
                    };
                    this.rescue_selectedAmphur = {
                        amphur_id: val.amphur_id,
                        amphur_name: val.amphur_name
                    };
                    this.rescue_selectedTambon = {
                        tambon_id: val.tambon_id,
                        tambon_name: val.tambon_name
                    };
                } else {
                    this.rescue_selectedProvince = null;
                }
            }
        },
        contact_phone(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone = false;
            }
        },
        contact_phone_office(val) {
            // console.log(val)
            if (val.length == 0) {
                this.error_contact_phone_office = false;
                this.contact_phone_office_ext = '';
            }
        },
        showOrganize(val) {
            if (val == true) {
                if (this.organize_table.length > 0) {
                    this.parentmessage_organize = this.organize_table;
                } else {
                    this.parentmessage_organize = [];
                }
            }
        },

        // Doe PDF เลือกได้
        columnsSelector(val) {
            // console.log(val)
            if (val.length == 0) {
                this.volunteer_rescue_Table = [];
            } else {
                this.volunteer_rescue_Table = this.cloneTable;
            }
        }

        // check_duplicate(val) {
        //   if (val == "duplicate evacuation") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลพื้นที่อพยพไม่สำเร็จ",
        //     //   detail: "มีข้อมูลพื้นที่อพยพนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลพื้นที่อพยพไม่สำเร็จ",
        //           text: "มีข้อมูลพื้นที่อพยพนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลพื้นที่อพยพ",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title: "เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลพื้นที่อพยพ",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },
    mounted() {},

    created() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });

        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;

        for (let index = 0; index < this.columnsSelector.length; index++) {
            this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
        }
        // Doe PDF เลือกได้  4/5  จบ
        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedVolunteerRescue.map((item) => ({
                    rescue_id: item.rescue_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/update/volunteer-rescue/dates?user=${userId}`, {
                    body: {
                        selectedVolunteerRescue: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.volunteerRescueModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลจุดอาสาสมัครจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchVolunteerRescue();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedVolunteerRescue = [...this.volunteer_rescue_Table];
            } else {
                this.selectedVolunteerRescue = [];
            }
            this.$emit('selectedVolunteerRescue', this.selectedVolunteerRescue);
            // console.log('selectedVolunteerRescue', this.selectedVolunteerRescue);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedVolunteerRescue.some((item) => item.rescue_id === row.rescue_id)) {
                    this.selectedVolunteerRescue.push(row);
                }
            } else {
                this.selectedVolunteerRescue = this.selectedVolunteerRescue.filter((item) => item.rescue_id !== row.rescue_id);
            }
            this.$emit('selectedVolunteerRescue', this.selectedVolunteerRescue);
            // console.log('selectedVolunteerRescue', this.selectedVolunteerRescue);
        },

        formatThaiDate(date) {
            if (!date) return null;
            const thaiMonths = [
                'มกราคม',
                'กุมภาพันธ์',
                'มีนาคม',
                'เมษายน',
                'พฤษภาคม',
                'มิถุนายน',
                'กรกฎาคม',
                'สิงหาคม',
                'กันยายน',
                'ตุลาคม',
                'พฤศจิกายน',
                'ธันวาคม'
            ];
            const d = new Date(date);
            const day = d.getDate();
            const month = thaiMonths[d.getMonth()];
            const year = d.getFullYear() + 543; // Convert to Thai Buddhist year
            return `${day} ${month} ${year}`;
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_1_search') && !this.isFocused('TextBox_3_search') && !this.isFocused('TextBox_4_search')) {
                    this.searchVolunteerRescue();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_5') &&
                    !this.isFocused('TextBox_6') &&
                    !this.isFocused('TextBox_15') &&
                    !this.isFocused('TextBox_17') &&
                    !this.isFocused('TextBox_18')
                ) {
                    this.saveData();
                }
            }
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterOptions = response.data.data),
                        this.disasterOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter.trim() !== '' && this.volunteer_rescue_Table.length > 0) {
                    const lowercaseFilter = this.filter.toLowerCase();

                    this.volunteer_rescue_Table = this.cloneTable.filter((item) => {
                        const matchesFilter = (value) => {
                            if (value == null) return false;
                            return String(value).toLowerCase().includes(lowercaseFilter);
                        };

                        return (
                            (this.columns_rescue_name && matchesFilter(item.rescue_name)) ||
                            (this.columns_rescue_unit_th && matchesFilter(item.rescue_unit_th)) ||
                            (this.columns_rescue_code && matchesFilter(item.rescue_code)) ||
                            (this.columns_rescue_status && matchesFilter(item.rescue_status)) ||
                            (this.columns_fire_station && matchesFilter(item.fire_station)) ||
                            (this.columns_service_time && matchesFilter(item.service_time)) ||
                            (this.columns_subdistrict && matchesFilter(item.subdistrict)) ||
                            (this.columns_country && matchesFilter(item.country)) ||
                            (this.columns_province && matchesFilter(item.province)) ||
                            (this.columns_rescue_latitude && matchesFilter(item.rescue_latitude)) ||
                            (this.columns_rescue_longitude && matchesFilter(item.rescue_longitude)) ||
                            (this.columns_rescue_remark && matchesFilter(item.rescue_remark)) ||
                            (this.columns_date_create && matchesFilter(item.date_create_ddmmyy)) ||
                            (this.columns_date_update && matchesFilter(item.date_update_ddmmyy))
                        );
                    });

                    // Update indices
                    this.volunteer_rescue_Table.forEach((item, index) => {
                        item.index = index + 1;
                    });
                } else {
                    this.volunteer_rescue_Table = this.cloneTable.map((item, index) => ({
                        ...item,
                        index: index + 1
                    }));
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },
        // Doe ค้นหา  3/6 จบ
        onFileChange(e) {
            document.getElementById('organize_uploadImageFile').click();

            if (e.type !== 'click') {
                if (e.target.files[0] != undefined) {
                    // let imgSize = e.target.files[0];
                    // if (imgSize.size > 7340032) {
                    //   this.$fire({
                    //     type: "warning",
                    //     title: "ขนาดไฟล์ใหญ่เกินไป",
                    //     text: "กรุณาใส่เฉพาะไฟล์รูปภาพไม่เกิน 7 MB.",
                    //     timer: 3000,
                    //     confirmButtonColor: "#28B463",
                    //   });
                    //   this.clearImage();
                    // } else {
                    if (e.target.files[0].type.split('/')[0] == 'image') {
                        const file = e.target.files[0];
                        this.url = URL.createObjectURL(file);
                        var reader = new FileReader();

                        reader.onload = (e) => {
                            var img = document.createElement('img');
                            img.onload = () => {
                                var canvas = document.createElement('canvas');
                                var ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0);

                                // var MAX_WIDTH = 800;
                                // var MAX_HEIGHT = 800;
                                var MAX_WIDTH = 250;
                                var MAX_HEIGHT = 250;
                                var width = img.width;
                                var height = img.height;

                                if (width > height) {
                                    if (width > MAX_WIDTH) {
                                        height *= MAX_WIDTH / width;
                                        width = MAX_WIDTH;
                                    }
                                } else {
                                    if (height > MAX_HEIGHT) {
                                        width *= MAX_HEIGHT / height;
                                        height = MAX_HEIGHT;
                                    }
                                }
                                canvas.width = width;
                                canvas.height = height;
                                ctx = canvas.getContext('2d');
                                ctx.drawImage(img, 0, 0, width, height);

                                var dataurl = canvas.toDataURL('image/png');
                                let console = {};
                                let logger = document.getElementById('io_image');
                                console.log = (text) => {
                                    let txt = document.createTextNode(text);
                                    logger.appendChild(txt);
                                };
                                // console.log(dataurl);
                            };
                            img.src = e.target.result;
                        };
                        reader.readAsDataURL(file);
                    } else {
                        // this.$toast.add({
                        //   severity: "error",
                        //   summary: "ประเภทไฟล์ผิดพลาด",
                        //   detail: "กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น",
                        //   life: 3000,
                        // });
                        this.$fire({
                            type: 'error',
                            title: 'ประเภทไฟล์ผิดพลาด',
                            text: 'กรุณาใส่เฉพาะไฟล์รูปภาพเท่านั้น',
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });
                        this.url = null;
                        document.getElementById('organize_uploadImageFile').value = '';
                    }
                    // }
                } else {
                    this.url = null;
                }
            }
        },

        clearImage() {
            this.url = null;
            document.getElementById('organize_uploadImageFile').value = '';
        },
        showImage(data) {
            if (data === null) {
                this.imgTable = null;
            } else if (data) {
                this.imgTable = [data];
            } else {
                this.imgTable = null;
            }
            // console.log(this.imgTable[0].data)
            // console.log("responsiveOptions",this.responsiveOptions)
            // this.displayImageModal = true;
            this.displayBasic2 = true;
        },

        async initialData() {
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterOptions = response.data.data),
                        this.disasterOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });

            // Doe : เพิ่ม ลำดับ 3/4 จบ
            await this.axios
                .post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                })
                .then((response) => {
                    (this.provinceOptions = response.data.data),
                        this.provinceOptions.splice(0, 0, {
                            province_id: 'getall',
                            province_name: this.$i18n.t('selectAll')
                        });
                });
            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].disaster == null || data[index].disaster == 'null' || data[index].disaster == '') {
                    data[index].disaster = '-';
                }
                if (data[index].evacuation_lat == null || data[index].evacuation_lat == 'null' || data[index].evacuation_lat == '') {
                    data[index].evacuation_latn = '-';
                }
                if (data[index].evacuation_lon == null || data[index].evacuation_lon == 'null' || data[index].evacuation_lon == '') {
                    data[index].evacuation_lon = '-';
                }
                if (data[index].evacuation_location == null || data[index].evacuation_location == 'null' || data[index].evacuation_location == '') {
                    data[index].evacuation_location = '-';
                }
                if (data[index].evacuation_lat) {
                    data[index].evacuation_lat = parseFloat(data[index].evacuation_lat).toFixed(6);
                }
                if (data[index].evacuation_lon) {
                    data[index].evacuation_lon = parseFloat(data[index].evacuation_lon).toFixed(6);
                }
                if (
                    data[index].evacuation_contact_name == null ||
                    data[index].evacuation_contact_name == 'null' ||
                    data[index].evacuation_contact_name == ''
                ) {
                    data[index].evacuation_contact_name = '-';
                }
                if (
                    data[index].evacuation_contact_phone == null ||
                    data[index].evacuation_contact_phone == 'null' ||
                    data[index].evacuation_contact_phone == ''
                ) {
                    data[index].evacuation_contact_phone = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        closeAllModal() {
            // console.log("Close and don`t save data");
            this.volunteerRescueModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        // acceptNumberPhone() {
        //   var x = this.rescue_contact_phone
        //     .replace(/\D/g, "")
        //     .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        //   this.rescue_contact_phone = !x[2]
        //     ? x[1]
        //     : x[1] + "-" + x[2] + (x[3] ? "-" + x[3] : "");
        // },

        someHandler(message) {
            if (message == 'ch-province') {
                this.rescue_selectedAmphur = null;
            }
            if (message == 'ch-amphur') {
                this.rescue_selectedTambon = null;
            }
        },

        selectedOrganize_passValue(variable) {
            this.showOrganize = false;
            if (variable != null) {
                if (this.setOpenModal_OrganizeMulti === 'search') {
                    this.organize_table = [];
                    for (let i = 0; i < variable.length; i++) {
                        this.organize_table.push({
                            organize_id: variable[i].organize_id,
                            fs_tname: variable[i].fs_tname
                        });
                    }
                }
            }
        },
        checkSelectedOrganize(status) {
            if (status !== '') {
                return true;
            } else {
                return false;
            }
        },
        selectedOrganize_passValue_Form(variable) {
            this.showOrganize_Form = false;
            if (this.volunteerRescueModal == false) {
                this.selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.fs_tname
                };
            } else {
                this.rescue_selectedOrganize = {
                    id: variable.organize_id,
                    name: variable.fs_tname
                };
            }
        },

        async searchVolunteerRescue() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.cloneTable = [];
            this.loading = true;

            try {
                let response;
                let organize = this.organize_table;

                response = await this.axios.post(`${this.$url_service}/search/volunteer/rescue`, {
                    userOrg,
                    organize,
                    r_name: this.r_name || '',
                    r_code: this.r_code || '',
                    r_unit_th: this.r_unit_th || '',
                    r_status: this.r_status || ''
                });

                // console.log('organize', this.organize_table);

                if (response.data && response.data.length > 0) {
                    this.volunteer_rescue_Table = response.data;

                    // Add an index to each row
                    this.volunteer_rescue_Table.forEach((item, index) => {
                        item.index = index + 1;
                    });

                    // Format the data (e.g., replace empty fields with dashes)
                    this.formatData(this.volunteer_rescue_Table);

                    // Clone the data for further use
                    this.cloneTable = [...this.volunteer_rescue_Table];

                    // Set up search text and footer
                    this.setSearchText_Footer();

                    // Perform any necessary searches/filtering
                    this.search();
                } else {
                    // If no data is returned, clear the table
                    this.volunteer_rescue_Table = [];
                }
            } catch (error) {
                console.error('Error Volunteer Rescue details:', error);
            } finally {
                this.loading = false;
            }

            if (this.columns_disabled) {
                this.volunteer_rescue_Table = [...this.cloneTable];
            } else {
                this.volunteer_rescue_Table = [];
            }

            this.search();
        },

        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (
                this.organize_table.length !== 0 ||
                this.rescue_name !== '' ||
                this.disasterSelect !== null ||
                this.selectedProvince !== null ||
                this.selectedAmphur !== null ||
                this.selectedTambon !== null
            ) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];
                    if (element.DataName === 'หน่วยงานที่รับผิดชอบ' && this.organize_table.length !== 0) {
                        element.textShow = this.setAll_organize_table(this.organize_table);
                    }
                    if (element.DataName === 'ชื่อพื้นที่อพยพ' && this.rescue_name !== '') {
                        element.textShow = this.rescue_name;
                    }
                    if (element.DataName === 'สาธารณภัยที่รองรับ' && this.disasterSelect !== null) {
                        element.textShow = this.disasterSelect.system_name;
                    }
                    if (element.DataName === 'จังหวัด' && this.selectedProvince !== null) {
                        element.textShow = this.selectedProvince.province_name;
                    }
                    if (element.DataName === 'เขต/อำเภอ' && this.selectedAmphur !== null) {
                        element.textShow = this.selectedAmphur.amphur_name;
                    }
                    if (element.DataName === 'แขวง/ตำบล' && this.selectedTambon !== null) {
                        element.textShow = this.selectedTambon.tambon_name;
                    }

                    this.text_Footer = true;
                }
            }
        },
        setAll_organize_table(data) {
            let text = [];
            for (let index = 0; index < data.length; index++) {
                const element = data[index];
                if (element.fs_tname !== undefined) {
                    text += element.fs_tname + ',';
                }
            }
            return text.slice(0, -1);
        },

        selectMap_passValue(variable) {
            // this.displayMap = false;
            this.rescue_lat = variable.lat;
            this.rescue_lon = variable.lng;
        },
        selectMap_displayMap() {
            this.displayMap = false;

            // แจ้งเตือนกรณีไม่ได้ ข้อมูลพิกัด
            // console.log("this.rescue_lat",this.rescue_lat)
            // console.log("this.rescue_lon",this.rescue_lon)
            if (this.rescue_lat !== null && this.rescue_lon !== null && this.rescue_lat !== '' && this.rescue_lon !== '') {
                this.$fire({
                    title: 'เพิ่มพิกัดสำเร็จ',
                    // text: "ข้อมูลพิกัด",
                    type: 'success',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } else {
                this.$fire({
                    title: 'ยังไม่ได้เลือกข้อมูลพิกัด',
                    // text: "ยังไม่ได้เลือกข้อมูลพิกัด",
                    type: 'warning',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        //  Doe เพิ่มหมุด map V.2 6/9  -->
        async inputMap_latlon() {
            if (this.rescue_lat !== '' && this.rescue_lat !== null && this.rescue_lon !== '' && this.rescue_lon !== null) {
                await this.axios
                    .get(`https://api.deemap.com/service/geocode/lat=${this.rescue_lat}/lon=${this.rescue_lon}/key=0feb00d7e64c5686bf434b9b90ab2d3c`)
                    .then((response) => {
                        // debugger;
                        if (response.data.data.length > 0) {
                            const data = {
                                ADMIN_CODE: response.data.data[0].ADMIN_CODE,
                                provinceName: response.data.data[0].PROV_TNAME,
                                amphurName: response.data.data[0].AMP_TNAME,
                                tambonName: response.data.data[0].TAM_TNAME,
                                postCODE: response.data.data[0].POSTCOD
                            };
                            const element = data.ADMIN_CODE;
                            const country_ID = `${element[0]}${element[1]}`;
                            const land_ID = `${element[2]}${element[3]}`;
                            const province_ID = `${element[4]}${element[5]}`;
                            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
                            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

                            if (country_ID == '66' && land_ID !== '00') {
                                this.rescue_selectedProvince = {
                                    province_name: data.provinceName,
                                    province_id: province_ID
                                };
                                this.rescue_selectedAmphur = {
                                    amphur_name: data.amphurName,
                                    amphur_id: amphur_ID
                                };
                                this.rescue_selectedTambon = {
                                    tambon_name: data.tambonName,
                                    tambon_id: tambon_ID
                                };

                                this.error_latlon_country = false;
                                this.error_latlon_land = false;

                                this.error_latlon_P = false;
                                this.error_latlon_A = false;
                                this.error_latlon_T = false;
                            } else {
                                if (country_ID !== '66') {
                                    this.error_latlon_country = true;
                                } else {
                                    this.error_latlon_country = false;
                                }
                                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                                    this.error_latlon_P = true;
                                } else {
                                    this.error_latlon_P = false;
                                }
                                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                                    this.error_latlon_A = true;
                                } else {
                                    this.error_latlon_A = false;
                                }
                                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                                    this.error_latlon_T = true;
                                } else {
                                    this.error_latlon_T = false;
                                }
                                this.rescue_selectedProvince = null;
                                this.rescue_selectedAmphur = null;
                                this.rescue_selectedTambon = null;
                            }

                            // console.log("this.rescue_selectedProvince",this.rescue_selectedProvince)
                            // console.log("this.rescue_selectedAmphur",this.rescue_selectedAmphur)
                            // console.log("this.rescue_selectedTambon",this.rescue_selectedTambon)
                        } else {
                            this.rescue_selectedProvince = null;
                            this.rescue_selectedAmphur = null;
                            this.rescue_selectedTambon = null;

                            this.error_latlon_country = false;
                            this.error_latlon_land = false;

                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        }
                    });
            } else {
                this.rescue_selectedProvince = null;
                this.rescue_selectedAmphur = null;
                this.rescue_selectedTambon = null;

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            }
        },

        async inputMap_PAT_latlon() {
            // console.log("<<<<<<<<<<<<<<<MMMMMMMMMMMMMM>>>>>>>>>>>>>>>")
            //   console.log("this.rescue_selectedProvince",this.rescue_selectedProvince)
            //   console.log("this.rescue_selectedAmphur",this.rescue_selectedAmphur)
            //   console.log("this.rescue_selectedTambon",this.rescue_selectedTambon)

            const url = 'https://service.deemap.com/service/gismis/boundary/geojson';

            let nnP = '';
            if (this.rescue_selectedProvince) {
                this.sP.push(this.rescue_selectedProvince.province_name);
                nnP = this.sP.length - 2;
            }

            let nnA = '';
            if (this.rescue_selectedAmphur) {
                this.sA.push(this.rescue_selectedAmphur.amphur_name);
                nnA = this.sA.length - 2;
            }

            if (this.rescue_selectedProvince == null) {
                this.rescue_lat = '';
                this.rescue_lon = '';

                this.error_latlon_country = false;
                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else if (this.rescue_selectedAmphur == null) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.rescue_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.rescue_lat = lat;
                        this.rescue_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sP[nnP] !== this.rescue_selectedProvince.province_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'province',
                        type: 'point',
                        id: this.rescue_selectedProvince.province_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.rescue_lat = lat;
                        this.rescue_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else if (this.sA[nnA] !== this.rescue_selectedAmphur.amphur_name) {
                await this.axios
                    .post(url, {
                        key: '78e731027d8fd50ed642340b7c9a63b3',
                        topic: 'amphoe',
                        type: 'point',
                        id: this.rescue_selectedAmphur.amphur_id
                    })
                    .then((response) => {
                        let getData = response.data.data;

                        const lon = getData.features[0].geometry.coordinates[0];
                        const lat = getData.features[0].geometry.coordinates[1];

                        this.rescue_lat = lat;
                        this.rescue_lon = lon;

                        this.error_latlon_country = false;
                        this.error_latlon_P = false;
                        this.error_latlon_A = false;
                        this.error_latlon_T = false;
                    });
            } else {
                if (this.rescue_selectedTambon) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'tambon',
                            type: 'point',
                            id: this.rescue_selectedTambon.tambon_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.rescue_lat = lat;
                            this.rescue_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.rescue_selectedAmphur) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'amphoe',
                            type: 'point',
                            id: this.rescue_selectedAmphur.amphur_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.rescue_lat = lat;
                            this.rescue_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else if (this.rescue_selectedProvince) {
                    await this.axios
                        .post(url, {
                            key: '78e731027d8fd50ed642340b7c9a63b3',
                            topic: 'province',
                            type: 'point',
                            id: this.rescue_selectedProvince.province_id
                        })
                        .then((response) => {
                            let getData = response.data.data;

                            const lon = getData.features[0].geometry.coordinates[0];
                            const lat = getData.features[0].geometry.coordinates[1];

                            this.rescue_lat = lat;
                            this.rescue_lon = lon;

                            this.error_latlon_country = false;
                            this.error_latlon_P = false;
                            this.error_latlon_A = false;
                            this.error_latlon_T = false;
                        });
                } else {
                    this.rescue_lat = '';
                    this.rescue_lon = '';
                }
            }
        },
        //  Doe เพิ่มหมุด map V.2 6/9  จบ-->

        async confirmDelete() {
            if (this.deleteTable == 'organize') {
                this.displayConfirmation = false;
                this.organize_table = this.organize_table.filter((val) => val !== this.organizeDelete);
            }

            if (this.deleteAt === 'volunteerRescue') {
                this.displayConfirmation = false;
                this.volunteer_rescue_Table = this.volunteer_rescue_Table.filter((val) => val !== this.volunteerRescueDelete);
            }

            try {
                const userId = this.getUsername();
                await this.axios.post(`${this.$url_service}/delete/volunteer/rescue?user=${userId}`, {
                    rescue_id: this.temp
                });

                this.displayConfirmation = false;
                this.searchVolunteerRescue();

                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลจุดอาสาสมัคร',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            } catch (error) {
                console.error('Error deleting organization data:', error);
                this.$fire({
                    type: 'error',
                    title: 'ลบข้อมูลไม่สำเร็จ',
                    text: 'เกิดข้อผิดพลาดในการลบข้อมูลจุดอาสาสมัคร',
                    timer: 3000,
                    confirmButtonColor: '#E74C3C'
                });
            }
        },

        async saveVolunteerRescue() {
            this.isEditMode = false;

            // Define the formatDate function
            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            let hasError = false;
            if (!this.rescue_name) {
                this.error_rescue_name = true;
                hasError = true;
            } else {
                this.error_rescue_name = false;
            }

            if (!this.rescue_unit_th) {
                this.error_rescue_unit_th = true;
                hasError = true;
            } else {
                this.error_rescue_unit_th = false;
            }

            if (!this.rescue_code) {
                this.error_rescue_code = true;
                hasError = true;
            } else {
                this.error_rescue_code = false;
            }

            if (!this.rescue_status) {
                this.error_rescue_status = true;
                hasError = true;
            } else {
                this.error_rescue_status = false;
            }

            if (!this.rescue_selectedOrganize) {
                this.error_rescue_selectedOrganize = true;
                hasError = true;
            } else {
                this.error_rescue_selectedOrganize = false;
            }

            if (!this.service_time) {
                this.error_service_time = true;
                hasError = true;
            } else {
                this.error_service_time = false;
            }

            if (!this.rescue_selectedProvince) {
                this.error_rescue_selectedProvince = true;
                hasError = true;
            } else {
                this.error_rescue_selectedProvince = false;
            }

            if (!this.rescue_selectedAmphur) {
                this.error_rescue_selectedAmphur = true;
                hasError = true;
            } else {
                this.error_rescue_selectedAmphur = false;
            }

            if (!this.rescue_selectedTambon) {
                this.error_rescue_selectedTambon = true;
                hasError = true;
            } else {
                this.error_rescue_selectedTambon = false;
            }

            if (!this.rescue_lat) {
                this.error_rescue_lat = true;
                hasError = true;
            } else {
                this.error_rescue_lat = false;
            }

            if (!this.rescue_lon) {
                this.error_rescue_lon = true;
                hasError = true;
            } else {
                this.error_rescue_lon = false;
            }

            if (!this.rescue_remark) {
                this.error_rescue_remark = true;
                hasError = true;
            } else {
                this.error_rescue_remark = false;
            }

            // If any required field has an error, return and do not proceed
            if (hasError) {
                return;
            }

            this.$fire({
                title: 'ยืนยันการสร้างข้อมูล',
                text: 'คุณต้องการสร้างข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.value) {
                    try {
                        const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
                        const userId = this.getUsername();

                        const VolunteerRescueDetail = {
                            userOrg,
                            rescue_name: this.rescue_name,
                            rescue_unit_th: this.rescue_unit_th,
                            rescue_code: this.rescue_code,
                            rescue_status: this.rescue_status,
                            fire_station: this.rescue_selectedOrganize.name,
                            service_time: this.service_time,
                            province: this.rescue_selectedProvince.province_name,
                            country: this.rescue_selectedAmphur.amphur_name,
                            subdistrict: this.rescue_selectedTambon.tambon_name,
                            rescue_latitude: this.rescue_lat,
                            rescue_longitude: this.rescue_lon,
                            rescue_remark: this.rescue_remark,
                            date_create: currentDateString,
                            date_update: currentDateString
                        };

                        const payload = {
                            VolunteerRescueDetail
                        };

                        // console.log('payload', payload);

                        this.loadingCreate = true;
                        const response = await fetch(`${this.$url_service}/post/volunteer/rescue?user=${userId}`, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload)
                        });

                        if (!response.ok) {
                            const errorData = await response.json();
                            if (errorData.message && errorData.message.includes('duplicate')) {
                                throw new Error('มีข้อมูลซ้ำในระบบ: ' + errorData.message);
                            } else {
                                throw new Error(`Network response was not ok: ${response.statusText}`);
                            }
                        }

                        const data = await response.json();
                        // console.log('Volunteer Rescue Data posted successfully:', data);

                        this.$fire({
                            title: 'สำเร็จ',
                            text: 'ข้อมูลถูกบันทึกเรียบร้อยแล้ว!',
                            icon: 'success',
                            confirmButtonText: 'ตกลง'
                        }).then(() => {
                            this.evStationsInfoModal = false;
                        });
                    } catch (error) {
                        console.error('Error posting Volunteer Detail :', error);

                        this.$fire({
                            title: 'ข้อผิดพลาด',
                            text: 'มีข้อผิดพลาดในการบันทึกข้อมูล: ' + error.message,
                            icon: 'error',
                            confirmButtonText: 'ตกลง'
                        });
                    } finally {
                        this.loadingCreate = false;
                    }
                }
            });
        },

        handleAddClick() {
            this.isEditMode = false;
            this.volunteerRescueModal = true;
        },

        async updateVolunteerRescue(rescue_id) {
            // console.log('rescue_id = ' + rescue_id);

            this.isEditMode = true;
            // console.log('Hello Update!');

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }

            const currentDateString = formatDate(new Date());

            const result = await this.$fire({
                title: 'ยืนยันการอัปเดตข้อมูล',
                text: 'คุณต้องการอัปเดตข้อมูลนี้ใช่หรือไม่ ?',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            });

            if (result.value) {
                try {
                    const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์

                    this.loadingUpdate = true;

                    const VolunteerRescueDataDetail = {
                        rescue_id: this.temp,
                        rescue_name: this.rescue_name,
                        rescue_unit_th: this.rescue_unit_th,
                        rescue_code: this.rescue_code,
                        rescue_status: this.rescue_status,
                        fire_station: this.rescue_selectedOrganize.name,
                        service_time: this.service_time,
                        province: this.rescue_selectedProvince.province_name,
                        country: this.rescue_selectedAmphur.amphur_name,
                        subdistrict: this.rescue_selectedTambon.tambon_name,
                        rescue_latitude: this.rescue_lat,
                        rescue_longitude: this.rescue_lon,
                        rescue_remark: this.rescue_remark,
                        date_update: currentDateString,
                        userOrg
                    };

                    // console.log('VolunteerRescueDataDetail:', VolunteerRescueDataDetail);
                    const userId = this.getUsername();

                    const response = await fetch(`${this.$url_service}/update/volunteer/rescue?user=${userId}`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ VolunteerRescueDataDetail })
                    });

                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'An error occurred while updating the data');
                    }

                    const data = await response.json();
                    // console.log('Volunteer Rescue updated successfully:', data);

                    await this.$fire({
                        title: 'สำเร็จ',
                        text: 'ข้อมูลถูกอัปเดตเรียบร้อยแล้ว!',
                        icon: 'success',
                        confirmButtonText: 'ตกลง'
                    });

                    this.volunteerRescueModal = false;
                    // Optionally, refresh the data or update the local state
                    // await this.fetchVolunteerRescueData();
                } catch (error) {
                    console.error('Error updating volunteer rescue detail:', error);

                    await this.$fire({
                        title: 'ข้อผิดพลาด',
                        text: 'มีข้อผิดพลาดในการอัปเดตข้อมูล: ' + error.message,
                        icon: 'error',
                        confirmButtonText: 'ตกลง'
                    });
                } finally {
                    this.loadingUpdate = false;
                }
            }
        },

        async editData(rescue_id) {
            // console.log('Edit mode activated for rescue_id:', rescue_id);
            this.isEditMode = true;
            this.header = this.$i18n.t('ivr_modal_title_edit');

            function formatDate(date) {
                if (!date) return null;
                const d = new Date(date);
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                const year = d.getFullYear();
                return `${year}-${month}-${day}T00:00:00.000Z`;
            }

            const currentDateString = formatDate(new Date());

            this.rescue_id = rescue_id;

            try {
                // console.log('Making API request...');
                const response = await this.axios.post(`${this.$url_service}/search/edit/volunteer/rescue`, {
                    rescue_id: rescue_id
                });

                // console.log('API response received:', response);

                if (response.data && response.data.data) {
                    const data = response.data.data;
                    // console.log('Data found:', data);

                    // Populate the form with the retrieved data
                    this.selectedData = data;
                    this.rescue_id = data.VolunteerRescueDataDetail.rescue_id || '';
                    this.rescue_name = data.VolunteerRescueDataDetail.rescue_name || '';
                    this.rescue_unit_th = data.VolunteerRescueDataDetail.rescue_unit_th || '';
                    this.rescue_code = data.VolunteerRescueDataDetail.rescue_code || '';
                    this.rescue_status = data.VolunteerRescueDataDetail.rescue_status || '';
                    this.rescue_selectedOrganize = { name: data.VolunteerRescueDataDetail.fire_station || '' };
                    this.service_time = data.VolunteerRescueDataDetail.service_time || '';

                    // Fetch province options if not already fetched
                    await this.fetchProvinceOptions();
                    // Set province and fetch amphur options
                    const provinceName = data.VolunteerRescueDataDetail.province || '';
                    // console.log('Province name from API:', provinceName);
                    await this.setProvinceAndFetchAmphur(provinceName);

                    // Set amphur and fetch tambon options
                    const amphurName = data.VolunteerRescueDataDetail.country || '';
                    await this.setAmphurAndFetchTambon(amphurName);

                    // Set tambon
                    const tambonName = data.VolunteerRescueDataDetail.subdistrict || '';
                    this.setTambon(tambonName);

                    this.rescue_lat = data.VolunteerRescueDataDetail.rescue_latitude || '';
                    this.rescue_lon = data.VolunteerRescueDataDetail.rescue_longitude || '';
                    this.rescue_remark = data.VolunteerRescueDataDetail.rescue_remark || '';
                    this.date_create_form = this.formatThaiDate(data.VolunteerRescueDataDetail.date_create) || '';
                    this.date_update_form = this.formatThaiDate(currentDateString) || '';

                    // Remove existing focus
                    document.activeElement.blur();

                    // Set focus to the first input field
                    this.$nextTick(() => {
                        if (this.$refs.TextBox_1) {
                            this.$refs.TextBox_1.focus();
                        }
                    });
                } else {
                    console.error('No data found for the given rescue_id:', rescue_id);
                }
            } catch (error) {
                console.error('Error fetching rescue data:', error);
            }
        },

        async fetchProvinceOptions() {
            try {
                const response = await this.axios.post(`${this.$url_service}/general/country`, {
                    body: { topic: 'get-province' }
                });
                this.provinceOptions = response.data.data;
                // console.log('Fetched province options:', this.provinceOptions);
            } catch (error) {
                console.error('Error fetching province options:', error);
            }
        },

        async setProvinceAndFetchAmphur(provinceName) {
            // console.log('Setting province:', provinceName);
            // console.log('Available provinces:', this.provinceOptions);

            const province = this.provinceOptions.find((p) => p.province_name.trim().toLowerCase() === provinceName.trim().toLowerCase());
            if (province) {
                // console.log('Found matching province:', province);
                this.rescue_selectedProvince = province; // Set the entire province object, not just the name
                await this.fetchAmphurOptions(province.province_id);
            } else {
                console.warn('No matching province found for:', provinceName);
                this.rescue_selectedProvince = null;
            }
        },

        async fetchAmphurOptions(provinceId) {
            const response = await this.axios.post(`${this.$url_service}/general/country`, {
                body: {
                    topic: 'get-amphur',
                    province_id: provinceId
                }
            });
            this.amphurOptions = response.data.data;
        },

        async setAmphurAndFetchTambon(amphurName) {
            const amphur = this.amphurOptions.find((a) => a.amphur_name === amphurName);
            if (amphur) {
                this.rescue_selectedAmphur = amphur;
                await this.fetchTambonOptions(amphur.amphur_id);
            }
        },

        async fetchTambonOptions(amphurId) {
            const response = await this.axios.post(`${this.$url_service}/general/country`, {
                body: {
                    topic: 'get-tambon',
                    amphur_id: amphurId
                }
            });
            this.tambonOptions = response.data.data;
        },

        setTambon(tambonName) {
            const tambon = this.tambonOptions.find((t) => t.tambon_name === tambonName);
            if (tambon) {
                this.rescue_selectedTambon = tambon;
            }
        },

        acceptNumberPhone() {
            var x = this.contact_phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            this.contact_phone = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone2() {
            var x = this.contact_phone_office.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})(\d{0,4})/);
            this.contact_phone_office = !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
        },
        acceptNumberPhone3() {
            var x = this.contact_phone_office_ext.replace(/\D/g, '');
            this.contact_phone_office_ext = x;
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            this.multiSelectClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('เพิ่มข้อมูลจุดอาสาสมัคร');
                this.temp = null;
                this.displayConfirmation = false;
                this.volunteerRescueModal = false;
                this.selectedData = '';
                this.setDefault();

                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.rescue_selectedOrganize = {};
            this.temp = null;
            this.rescue_name = '';
            this.rescue_unit_th = '';
            this.rescue_code = '';
            this.rescue_status = '';
            this.service_time = '';

            this.rescue_location_detail = '';
            this.rescue_selectedProvince = null;
            this.rescue_selectedAmphur = null;
            this.rescue_selectedTambon = null;
            this.rescue_access_main = '';
            this.rescue_access_tempolary = '';
            this.rescue_entry = '';
            this.rescue_exit = '';
            this.rescue_area = '';
            this.rescue_capacity = '';
            this.rescue_contact_name = '';
            this.rescue_contact_phone = '';
            this.rescue_lat = '';
            this.rescue_lon = '';
            this.rescue_remark = '';
            this.rescue_selectedDisaster = null;
            this.error_rescue_organize = false;
            this.error_rescue_name = false;
            this.error_rescue_unit_th = false;
            this.error_rescue_code = false;
            this.error_rescue_status = false;
            this.error_service_time = false;
            this.error_rescue_selectedProvince = false;
            this.error_rescue_selectedAmphur = false;
            this.error_rescue_selectedTambon = false;
            this.error_rescue_lat = false;
            this.error_rescue_lon = false;
            this.error_rescue_remark = false;

            this.disaster_table = [];
            this.selectedProvince = null;

            this.contact_phone = '';
            this.contact_phone_office = '';
            this.contact_phone_office_ext = '';

            this.error_contact_phone = false;
            this.error_contact_phone_office = false;
            this.error_contact_phone_office_ext = false;

            this.error_latlon_country = false;
            this.error_latlon_land = false;
            this.error_latlon_P = false;
            this.error_latlon_A = false;
            this.error_latlon_T = false;

            this.url = null;
            document.getElementById('organize_uploadImageFile').value = '';

            this.date_create_form = '';
            this.date_update_form = '';
        },
        async clearSearchField() {
            this.r_name = '';
            this.r_code = '';
            this.r_unit_th = '';
            this.r_status = '';
            this.volunteer_rescue_Table = [];
            this.organize_table = [];

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.r_name = '';
                this.r_code = '';
                this.r_unit_th = '';
                this.r_status = '';

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        // Doe :   เพิ่ม มุดmap 4/4
        sendM(rescue_lat, rescue_lon) {
            let lat = rescue_lat;
            let lon = rescue_lon;
            this.latlon = { lat, lon };
            // console.log("send ",this.latlon)
        },
        sendM_PAT(tambon, amphur, province) {
            if (tambon) {
                this.PAT = tambon;
                // console.log("this.PAT=tambon",this.PAT)
            } else if (amphur) {
                this.PAT = amphur;
                // console.log("amphur",amphur)
            } else if (province) {
                this.PAT = province;
                // console.log("province",province)
            } else {
                this.PAT = {};
                // console.log("this.PAT={}",this.PAT)
            }
        },
        //  Doe เพิ่มหมุด map V.2 8/9  -->
        receiveM_PAT(data) {
            // console.log("data",data)
            const element = data.ADMIN_CODE;
            const country_ID = `${element[0]}${element[1]}`;
            const land_ID = `${element[2]}${element[3]}`;
            const province_ID = `${element[4]}${element[5]}`;
            const amphur_ID = `${element[4]}${element[5]}${element[6]}${element[7]}`;
            const tambon_ID = `${element[4]}${element[5]}${element[6]}${element[7]}${element[8]}${element[9]}`;

            if (country_ID == '66' && land_ID !== '00') {
                this.rescue_selectedProvince = {
                    province_name: data.provinceName,
                    province_id: province_ID
                };
                this.rescue_selectedAmphur = {
                    amphur_name: data.amphurName,
                    amphur_id: amphur_ID
                };
                this.rescue_selectedTambon = {
                    tambon_name: data.tambonName,
                    tambon_id: tambon_ID
                };

                this.error_latlon_country = false;
                this.error_latlon_land = false;

                this.error_latlon_P = false;
                this.error_latlon_A = false;
                this.error_latlon_T = false;
            } else {
                if (country_ID !== '66') {
                    this.error_latlon_country = true;
                } else {
                    this.error_latlon_country = false;
                }
                // if(land_ID == "00"){
                //   this.error_latlon_land = true
                // }else{
                //   this.error_latlon_land = false
                // }

                if (data.provinceName == null || data.provinceName == 'null' || data.provinceName == '' || data.provinceName == ' ') {
                    this.error_latlon_P = true;
                } else {
                    this.error_latlon_P = false;
                }
                if (data.amphurName == null || data.amphurName == 'null' || data.amphurName == '' || data.amphurName == ' ') {
                    this.error_latlon_A = true;
                } else {
                    this.error_latlon_A = false;
                }
                if (data.tambonName == null || data.tambonName == 'null' || data.tambonName == '' || data.tambonName == ' ') {
                    this.error_latlon_T = true;
                } else {
                    this.error_latlon_T = false;
                }

                this.rescue_selectedProvince = null;
                this.rescue_selectedAmphur = null;
                this.rescue_selectedTambon = null;
            }

            // console.log("receiveM_PAT-------------------")
            // console.log("country_ID",country_ID)
            // console.log("land_ID",land_ID)
            // console.log("this.rescue_selectedProvince",this.rescue_selectedProvince)
            // console.log("this.rescue_selectedAmphur",this.rescue_selectedAmphur)
            // console.log("this.rescue_selectedTambon",this.rescue_selectedTambon)
        },
        //  Doe เพิ่มหมุด map V.2 8/9  จบ-->
        // Doe :   เพิ่ม มุดmap 4/4 จบ

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log(temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },

        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            } else if (this.columnsSelectorDialog.length <= 6) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 13;
                this.PDF_FontBodyVer = 11;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 },
                    rescue_name: { cellWidth: 65 },
                    text_tel_detail: { cellWidth: 85 },

                    date_update_ddmmyy: { cellWidth: 70 }
                };

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 },
                    evacuation_location: { cellWidth: 80 },
                    rescue_name: { cellWidth: 100 },
                    text_tel_detail: { cellWidth: 105 }
                };
            } else {
                this.PDF_minCellWidthVer = 60;
                this.PDF_FontHeaderVer = 10;
                this.PDF_FontBodyVer = 7;

                this.PDF_BodySizeSelect = this.PDF_BodySize;

                this.PDF_minCellWidthHor = 80;
                this.PDF_FontHeaderHor = 13;
                this.PDF_FontBodyHor = 11;

                this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
            }

            this.columnsSelector = this.columnsSelectorDialog;

            if (this.columnsSelector.length == 0) {
                this.columns_index = false;
                this.columns_rescue_name = false;
                this.columns_rescue_unit_th = false;
                this.columns_rescue_code = false;
                this.columns_rescue_status = false;
                this.columns_fire_station = false;
                this.columns_service_time = false;
                this.columns_subdistrict = false;
                this.columns_country = false;
                this.columns_province = false;
                this.columns_rescue_latitude = false;
                this.columns_rescue_longitude = false;
                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                this.GetData_ColumnsSearch = [];
                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelector.length; index++) {
                    this.GetData_ColumnsSearch.push(this.columnsSelector[index].dataKey);
                }
                let getData = this.GetData_ColumnsSearch;
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelector.length; index++) {
                    const element = this.columnsSelector[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'image') {
                        this.columns_img = true;
                    } else if (!getData.includes('image')) {
                        this.columns_img = false;
                    }

                    if (element == 'evacuation_name') {
                        this.columns_evacuation_name = true;
                    } else if (!getData.includes('evacuation_name')) {
                        this.columns_evacuation_name = false;
                    }

                    if (element == 'disaster') {
                        this.columns_disaster = true;
                    } else if (!getData.includes('disaster')) {
                        this.columns_disaster = false;
                    }

                    if (element == 'rescue_name') {
                        this.columns_rescue_name = true;
                    } else if (!getData.includes('rescue_name')) {
                        this.columns_rescue_name = false;
                    }

                    if (element == 'evacuation_location') {
                        this.columns_evacuation_location = true;
                    } else if (!getData.includes('evacuation_location')) {
                        this.columns_evacuation_location = false;
                    }
                    if (element == 'evacuation_entry') {
                        this.columns_evacuation_entry = true;
                    } else if (!getData.includes('evacuation_entry')) {
                        this.columns_evacuation_entry = false;
                    }
                    if (element == 'evacuation_exit') {
                        this.columns_evacuation_exit = true;
                    } else if (!getData.includes('evacuation_exit')) {
                        this.columns_evacuation_exit = false;
                    }
                    if (element == 'evacuation_area') {
                        this.columns_evacuation_area = true;
                    } else if (!getData.includes('evacuation_area')) {
                        this.columns_evacuation_area = false;
                    }
                    if (element == 'evacuation_capacity') {
                        this.columns_evacuation_capacity = true;
                    } else if (!getData.includes('evacuation_capacity')) {
                        this.columns_evacuation_capacity = false;
                    }
                    if (element == 'evacuation_lat') {
                        this.columns_evacuation_latitude = true;
                    } else if (!getData.includes('evacuation_lat')) {
                        this.columns_evacuation_latitude = false;
                    }
                    if (element == 'evacuation_lon') {
                        this.columns_evacuation_longitude = true;
                    } else if (!getData.includes('evacuation_lon')) {
                        this.columns_evacuation_longitude = false;
                    }

                    if (element == 'evacuation_contact_name') {
                        this.columns_evacuation_contact_name = true;
                    } else if (!getData.includes('evacuation_contact_name')) {
                        this.columns_evacuation_contact_name = false;
                    }

                    // if (element == "evacuation_contact_phone") {
                    //   this.columns_evacuation_contact_phone = true
                    // } else if(!getData.includes("evacuation_contact_phone")){
                    //   this.columns_evacuation_contact_phone = false
                    // }

                    if (element == 'text_tel_detail') {
                        this.columns_evacuation_contact_phone = true;
                    } else if (!getData.includes('text_tel_detail')) {
                        this.columns_evacuation_contact_phone = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    },

    computed: {}
};
</script>

<style scoped>
/*   Doe เพิ่มหมุด map V.2 9/9  --> */
.warningLATLON {
    color: rgb(225, 144, 13);
    font-size: 0.9rem;
}
/*   Doe เพิ่มหมุด map V.2 9/9  จบ--> */
.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}

#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

.imgDia {
    width: 100%;
    display: block;
}

#preview img {
    /* height: 180px; */
    width: 234px;
    border: solid 1px #cccccc;
}

@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}
@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

:deep(.p-multiselect-panel) {
    .p-multiselect-items-wrapper {
        max-height: 150px !important;
    }
}

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
